import React, { useState } from "react";
import { useHistory } from "react-router";
import Sidebar from "../../partials/aside/Sidebar";
import validateFormAddCategortTicket from "../../../validtions/forms/ticket/add-category";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";

function AddCategoryTicket() {
  const history = useHistory();
  const [message, setMessage] = useState();

  let messageTag;

  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const addCategoryTicket = async (e) => {
    e.preventDefault();

    const title = document.getElementById("title").value;
    const resValidateFormAddCategoryTicket =
      validateFormAddCategortTicket(title);
    if (resValidateFormAddCategoryTicket != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: resValidateFormAddCategoryTicket,
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }

    const bodyRequest = {
      title: title,
    };

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (await sendRequestPostCategoryTicket(bodyRequest)) {
      history.push("/ticket/category-ticket");
      return;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestPostCategoryTicket = async (bodyRequest) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/ticket/categories-ticket",
        bodyRequest,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar openItem="tickets" />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">دسته جدید</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {messageTag}
              <form onSubmit={addCategoryTicket}>
                <div className="form-group">
                  <label>عنوان</label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    required
                  />
                </div>

                <button type="submit" className="btn btn-outline-primary">
                  ارسال
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AddCategoryTicket;
